import Introduction from "../components/Introduction";
import YellowIntroduction from "../components/YellowIntroduction";
import About from "../components/About";
import SlidedImage from "../components/SlidedImage";
import VisionAndMission from "../components/VisionAndMission";
import GroupCompanies from "../components/GroupCompanies";
import Policy from "../components/Policy";

const MainPage = ({scrollTargetRef}) => {
    return (<div style={{width: "100vw"}}>
        <SlidedImage></SlidedImage>
        <Introduction ref={scrollTargetRef[0]}></Introduction>
        <YellowIntroduction ref={scrollTargetRef[1]}></YellowIntroduction>
        <Policy ref={scrollTargetRef[3]}></Policy>
        <VisionAndMission ref={scrollTargetRef[2]}></VisionAndMission>
        <GroupCompanies></GroupCompanies>
        <About refProp={scrollTargetRef[2]}></About>
    </div>)
}

export default MainPage;